import React from "react";
import Dialog from "../../../../../../../common/element/Dialog";
import Table from "../../../../../../../common/element/Table";
import { useLocation } from "react-router-dom";
import { formatToolName } from "../../../../../../../common/Formatters.js/formatters";

const { Tr, Th, Td, THead, TBody } = Table;

const ViewResultDialog = ({ dialogOpen, onDialogClose, candidateData, resultData }) => {
  const location = useLocation();
  console.log(resultData, "candidateDatacandidateData");
  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get("tab");

  // Check if current URL matches your condition
  const isInterviewCandidateView =
    location.pathname.includes("/companies/companyview") &&
    tabFromUrl === "interviewCandidates";

  const scores = resultData?.data;
  console.log(scores, "scoresscores");

  // Check if this is N Codes tool (tool_id === 1, 2, or 3)
  const isNCodesResult = scores?.tool_id === 1 || scores?.tool_id === 2 || scores?.tool_id === 3;

  // Check if this is Baseline tool (tool_id === 5)
  const isBaselineResult = scores?.tool_id === 5;

  // Check if this is Personality Test tool (tool_id === 6)
  const isPersonalityTestResult = scores?.tool_id === 6;

  // Check if this is Traits Test tool (tool_id === 7)
  const isTraitsTestResult = scores?.tool_id === 7;

  // Helper function to capitalize first letter only
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // For tool_id 7, create dynamic rows from the score object
  const traitsTestRows = React.useMemo(() => {
    if (scores?.tool_id === 7 && scores?.score) {
      const scoreData = scores.score;
      const traits = [];

      // Extract trait names from the keys (remove 'Level' and 'Score' suffixes)
      const traitNames = Object.keys(scoreData)
        .filter(key => key.endsWith('Level'))
        .map(key => key.replace('Level', ''));

      traitNames.forEach(trait => {
        const levelKey = `${trait}Level`;
        const scoreKey = `${trait}Score`;
        traits.push({
          name: trait.charAt(0).toUpperCase() + trait.slice(1), // Capitalize first letter
          level: scoreData[levelKey] || '',
          score: scoreData[scoreKey] || 0
        });
      });

      // Sort by score descending
      return traits.sort((a, b) => b.score - a.score);
    }
    return [];
  }, [scores]);

  // For tool_id 6, create dynamic rows from the score object and sort by score descending
  const personalityTestRows = React.useMemo(() => {
    if (scores?.tool_id === 6 && scores?.score) {
      return Object.entries(scores.score)
        .map(([key, value]) => ({ key, value }))
        .sort((a, b) => b.value - a.value);
    }
    return [];
  }, [scores]);

  // Create rows array for original tool (tool_id 4) and sort by score in descending order
  const rows = [
    { key: 'Certainty', value: scores?.score?.Certainty || 0 },
    { key: 'Variety', value: scores?.score?.Variety || 0 },
    { key: 'Significance', value: scores?.score?.Significance || 0 },
    { key: 'Love/Connection', value: scores?.score?.['Love/Connection'] || 0 },
    { key: 'Growth', value: scores?.score?.Growth || 0 },
    { key: 'Contribution', value: scores?.score?.Contribution || 0 },
  ].sort((a, b) => b.value - a.value);

  // Get the highest score for highlighting (for personality test)
  const highestScore = personalityTestRows.length > 0 ? personalityTestRows[0]?.value : 0;

  // Get the highest score for highlighting (for traits test)
  const highestTraitScore = traitsTestRows.length > 0 ? traitsTestRows[0]?.score : 0;

  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={onDialogClose}
      width={isNCodesResult || isBaselineResult || isPersonalityTestResult || isTraitsTestResult ? 1000 : 700
      }
      onRequestClose={onDialogClose}
      bodyOpenClassName="overflow-hidden"
    >
      {/* Header */}
      < div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center justify-between" >
        <div className="flex items-center" >
          <span className="h-8 w-8 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4" >
            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M12 9H16.8C17.9201 9 18.4802 9 18.908 9.21799C19.2843 9.40973 19.5903 9.71569 19.782 10.092C20 10.5198 20 11.0799 20 12.2V19M12 19V4.2C12 3.0799 12 2.51984 11.782 2.09202C11.5903 1.71569 11.2843 1.40973 10.908 1.21799C10.4802 1 9.9201 1 8.8 1H5.2C4.0799 1 3.51984 1 3.09202 1.21799C2.71569 1.40973 2.40973 1.71569 2.21799 2.09202C2 2.51984 2 3.0799 2 4.2V19M21 19H1M5.5 5H8.5M5.5 9H8.5M5.5 13H8.5" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          < h5 className="mb-0 text-gray-900 text-base font-semibold" >
            {isInterviewCandidateView ? "View Result" : "View Result"}
          </h5>
        </div>

        < button
          onClick={onDialogClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Table Content */}
      <div className="px-6 pb-5" >
        {isInterviewCandidateView && (
          <>
            <h4 className="text-lg mb-3" > Assigned Tool Name: {formatToolName(scores?.tool)} </h4>
          </>
        )}

        {/* Baseline Result (tool_id === 5) */}
        {isBaselineResult ? (
          <div>
            <div className="grid grid-cols-3 gap-4">
              {scores?.score?.selected_questions?.map((item, index) => (
                <div
                  key={item.id}
                  className="bg-[#FF8E1C] transition-colors duration-200 rounded-lg px-6 py-2 h-[42px] text-white text-center font-medium text-base shadow-sm"
                >
                  {index + 1}. {item.text}
                </div>
              ))}
            </div>
          </div>
        ) : isNCodesResult ? (
          // N Codes Result
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-start">
              The E Codes Against Your 6 N Codes Are:
            </h3>

            {/* Column Headers */}
            <div className="grid grid-cols-2 gap-4 mb-[18px]">
              <div className="">
                <h4 className="text-[#FF8E1C] font-bold text-lg">
                  N Code:
                </h4>
              </div>
              <div className="pl-4">
                <h4 className="text-[#FF8E1C] font-bold text-lg text-end">
                  E Code:
                </h4>
              </div>
            </div>

            {/* Content Rows */}
            <div className="space-y-4">
              {scores?.score?.selected_codes?.map((item) => (
                <div key={item.id} className="grid grid-cols-[49%_1%_49%] gap-0 bg-[#FFF4E5] p-4 rounded-[8px] items-center">
                  {/* N Code Column */}
                  <div className="">
                    <p className="text-black text-[18px] leading-relaxed">
                      {item.ncode}
                    </p>
                  </div>
                  <div className="w-[1px] h-[100%] bg-black shrink-0"></div>
                  {/* E Code Column */}
                  <div className="pl-4">
                    <p className="text-black text-[18px] leading-relaxed">
                      {item.ecode}
                    </p>
                  </div>

                </div>
              ))}
            </div>
          </div>
        ) : isTraitsTestResult ? (
          // Traits Test Result (tool_id === 7)
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-start" >
              Traits Test Results
            </h3>

            < div className="rounded-lg border border-gray-200 overflow-hidden" >
              <Table>
                <THead>
                  <Tr className="bg-gray-50 text-left" >
                    <Th>
                      S No.
                    </Th>
                    <Th>
                      Trait
                    </Th>
                    <Th>
                      Level
                    </Th>
                    <Th>
                      Score
                    </Th>
                  </Tr>
                </THead>
                <TBody>
                  {
                    traitsTestRows?.map((item, index) => (
                      <Tr
                        key={item.name}
                        className="hover:bg-gray-50"
                      >
                        <Td className="py-3 px-4 text-sm text-gray-700" >
                          {String(index + 1).padStart(2, "0")
                          }
                        </Td>
                        <Td>
                          {item.name}
                        </Td>
                        < Td className="py-3 px-4 text-sm" >
                          <span>
                            {capitalizeFirstLetter(item.level)}
                          </span>
                        </Td>
                        < Td className="py-3 px-4 text-sm" >
                          <div className="flex items-center gap-3" >
                            <span>
                              {item.score}
                            </span>
                          </div>
                        </Td>
                      </Tr>
                    ))}
                </TBody>
              </Table>
            </div>
          </div>
        ) : isPersonalityTestResult ? (
          // Personality Test Result (tool_id === 6)
          <div>
            <div className="rounded-lg border border-gray-200 overflow-hidden">
              <Table>
                <THead>
                  <Tr className="bg-gray-50 text-left">

                    <Th className="py-3 px-4 ">
                      Personality Type
                    </Th>
                    <Th className="py-3 px-4">
                      Score
                    </Th>
                  </Tr>
                </THead>
                <TBody>
                  {personalityTestRows?.map((item, index) => (
                    <Tr
                      key={item.key}
                      className={`hover:bg-gray-50`}
                    >

                      <Td className={`py-3 px-4 text-sm ${item.value === highestScore
                        ? 'text-orange-600 font-semibold'
                        : 'text-gray-700'
                        }`}>
                        {item.key}

                      </Td>
                      <Td className="py-3 px-4 text-sm text-gray-700">
                        <div className="flex items-center gap-3">
                          <span className={`font-medium ${item.value === highestScore ? 'text-orange-600' : ''
                            }`}>
                            {item.value}
                          </span>

                        </div>
                      </Td>
                    </Tr>
                  ))}
                </TBody>
              </Table>
            </div>

          </div>
        ) : (
          // Original Personality Type Table (for other tool_ids like 4)
          <div className="rounded-lg border border-gray-200 overflow-hidden" >
            <Table>
              <THead>
                <Tr className="bg-gray-50 text-left" >
                  <Th>
                    S No.
                  </Th>
                  < Th className="py-3 px-4 text-xs font-semibold text-gray-600 w-[70%]" >
                    Personality Type
                  </Th>
                  < Th className="py-3 px-4 text-xs font-semibold text-gray-600 w-[20%]" >
                    Your Score
                  </Th>
                </Tr>
              </THead>
              <TBody>
                {
                  rows?.map((item, index) => (
                    <Tr key={item.key} className="hover:bg-gray-50" >
                      <Td className="py-3 px-4 text-sm text-gray-700" >
                        {String(index + 1).padStart(2, "0")
                        }
                      </Td>
                      < Td className="py-3 px-4 text-sm text-gray-700" >
                        {item.key}
                      </Td>
                      < Td className="py-3 px-4 text-sm text-gray-700" >
                        {item.value}
                      </Td>
                    </Tr>
                  ))}
              </TBody>
            </Table>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ViewResultDialog;